export default "/assets/site/images/hupx.png?316de0df45951a9cd42c16b939f27f7d";